import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { EasypayEmployeeMapping } from './easypay-employee-mapping.interface';

export class EasypayEmployeeMappingService {
   async getEasypayEmployeeMappings(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<EasypayEmployeeMapping>>(`/easypay-employee-mappings`, { params: { ...query } });

      return response.data;
   }
}
